// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import { AuthProvider } from './pages/context/AuthContext';
// import Homepage from './pages/Homepage';
// import AdminDashboard from './pages/admin/AdminDashboard';
// import LoginPage from './pages/LoginPage';
// import ChooseUser from './pages/ChooseUser';
// import StudentDashboard from './pages/student/stuDashboard';
// import PrivateRoute from './pages/PrivateRoute';
// import FacDashboard from './pages/Faculty/FacDashboard';
// import GuardedRoute from './pages/GaurdRoute';
// import OTPVerificationPage from './pages/OTPVerification';
// import StaffDashboard from './pages/Staff/staffDash';
// import RegisterSchool from './pages/RegisterSchool';
// import FirstPage from './pages/FirstPage';
// import Dashboard from './pages/Adminstrator/Dashboard';
// import AdministratorLogin from './pages/AdminstratorLogin';
// import ContactForm from './pages/Contact/contactForm';
// import Navbar from './components/Navbar';
// import FoodAnalysis from './pages/SchoolHomePage/FoodAnalysis';

// const App = () => {
//   // Hardcoded userType for testing purposes
//   const userType = localStorage.getItem('userType'); // Assuming you store userType in localStorage

//   return (
//     <>
//       <Navbar />
//       <div className='bg-gradient-to-r from-gray-900 to-gray-200 w-screen h-screen overflow-x-hidden overflow-scroll'>

//         <Routes>
//           <Route path="/" element={<Homepage />} />
//           <Route path="/firstPage" element={<PrivateRoute>
//             <FirstPage />
//           </PrivateRoute>} />
//           <Route path="/choose" element={<ChooseUser visitor="normal" />} />
//           <Route path="/otp-verification" element={<OTPVerificationPage />} />
//           <Route path="/loginPage" element={<LoginPage />} />
//           <Route path='/adminstratorLogin' element={<AdministratorLogin />} />
//           <Route path="/contactForm" element={<ContactForm />} />

//           <Route path="/registerSchool" element={<RegisterSchool />} />
//           <Route path="/Admin/dashboard" element={
//             <PrivateRoute>
//               <AdminDashboard />
//             </PrivateRoute>
//           } />
//           <Route path="/Adminstrator/dashboard" element={
//             <PrivateRoute>
//               <Dashboard />
//             </PrivateRoute>
//           } />
//           <Route path="/StudentDashboard" element={
//             <PrivateRoute>
//               <StudentDashboard />
//             </PrivateRoute>
//           } />
//           <Route path="/FacultyDashboard" element={
//             <PrivateRoute>
//               <FacDashboard />
//             </PrivateRoute>
//           } />
//           <Route path="/StaffDashboard" element={
//             <PrivateRoute>
//               <StaffDashboard />
//             </PrivateRoute>
//           } />
//           <Route path="/FoodAnalysis" element={
//             <PrivateRoute>
//               <FoodAnalysis />
//             </PrivateRoute>
//           } />
//           <Route path='*' element={<Navigate to="/" />} />
//         </Routes>

//       </div>
//     </>
//   );
// }

// export default App;



// import React from 'react';
// import { useEffect } from 'react';
// import { useDispatch } from 'react-redux';
// import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";

// import Homepage from './pages/Homepage';
// import AdminDashboard from './pages/admin/AdminDashboard';
// import LoginPage from './pages/LoginPage';

// import StudentDashboard from './pages/student/stuDashboard';
// import PrivateRoute from './pages/PrivateRoute';
// import FacDashboard from './pages/Faculty/FacDashboard';

// import StaffDashboard from './pages/Staff/staffDash';
// import RegisterSchool from './pages/RegisterSchool';

// import Dashboard from './pages/Adminstrator/Dashboard';

// import ContactForm from './pages/Contact/contactForm';
// import Navbar from './components/Navbar';

// import { getSubdomain } from './utils/Subdomain';
// import SchoolLandingPage from './SchoolPages/SchoolLandingPage';
// import { verifySession } from './features/auth/authSlice';

// const App = () => {
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(verifySession());
//   }, [dispatch]);

//   const subdomain = getSubdomain();
//   const isSchoolSite = subdomain && subdomain !== 'www' && subdomain !== 'localhost';

//   const location = useLocation();

//   // Routes where Navbar should be hidden
//   const hideNavbarRoutes = ['/Adminstrator/dashboard', '/Admin/dashboard', '/StudentDashboard', '/FacultyDashboard', '/StaffDashboard', 'FoodAnalysis'];

//   const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname) || isSchoolSite;

//   return (
//     <>

//       <div className='bg-gradient-to-r from-gray-900 to-gray-200 w-screen h-screen overflow-x-hidden'>
//         {!shouldHideNavbar && <Navbar />}
//         <Routes>
//           {isSchoolSite ? (
//             <Route path="*" element={<SchoolLandingPage />} />
//           ) : (
//             <Route path="*" element={<Homepage />} />
//           )}
         
        
//           <Route path="/loginPage" element={<LoginPage />} />
      
//           <Route path="/contactForm" element={<ContactForm />} />
//           <Route path="/registerSchool" element={<RegisterSchool />} />
//           <Route path="/Admin/dashboard" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
//           <Route path="/Adminstrator/dashboard" element={<Dashboard />} />
//           <Route path="/StudentDashboard" element={<PrivateRoute><StudentDashboard /></PrivateRoute>} />
//           <Route path="/FacultyDashboard" element={<PrivateRoute><FacDashboard /></PrivateRoute>} />
//           <Route path="/StaffDashboard" element={<PrivateRoute><StaffDashboard /></PrivateRoute>} />
      
//           <Route path='*' element={<Navigate to="/" />} />
//         </Routes>

//       </div>
//     </>
//   );
// };

// export default App;



// src/App.jsx

import React from 'react';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { verifySession } from './features/auth/authSlice';
import { getSubdomain } from './utils/Subdomain';

import MainApp from './MainApp';
import SchoolApp from './SchoolApp';

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(verifySession());
  }, [dispatch]);

  const subdomain = getSubdomain();
  const isSchoolSite = subdomain && subdomain !== 'www' && subdomain !== 'localhost';

  return (
   <>
      {isSchoolSite ? <SchoolApp /> : <MainApp />}
   </>
  );
};

export default App;

